module.exports = __webpack_public_path__ + "a6c9226a55d78bf5a16e757a373c52e4.png";